import $ from "jquery";

// facebook Page Pluginのイニシャライズ関数
function initFb(version, sdkURL) {
	if( document.getElementById("facebook-jssdk") ) {
		return;
	}
	
	const js = document.createElement("script");
	js.id = "facebook-jssdk";
	
	if(version && typeof version !== "number") {
		const floatVer = parseFloat(version);
		isNaN(floatVer) && (version = false);
	}
	
	// defautl version
	!version && (version = 6.0);
	
	if(!sdkURL || typeof sdkURL !== "string") {
		sdkURL = "https://connect.facebook.net/ja_JP/sdk.js#xfbml=1";
	}
	
	js.src = `${sdkURL}&version=v${version}`;
	const jsfirstElm = document.getElementsByTagName("script")[0];
	jsfirstElm.parentNode.insertBefore(js, jsfirstElm);
}

// 非同期ループ関数
function asyncLoop(judgeCB, endCB, time) {
	(typeof time === "number") || (time = 1);
	if( judgeCB() ) {
		endCB();
	} else {
		setTimeout(() => asyncLoop(judgeCB, endCB, time), time);
	}
}

$.fn.initFbPagePlugin = async function initFbPagePlugin(opt, ttl, version) {
	(typeof opt === "object") || (opt = {});
	
	const def = {
		"width": 500,
		"height": 500,
		"tabs": "timeline",				// 表示するタブです(timeline, events, messagesなど)。複数のタブを追加する場合は、コンマで区切って指定
		"hide-cta": false,				// カスタムのアクションボタンを非表示にします
		"small-header": false,		// 縮小版ヘッダの表示ON/OFF
		"hide-cover": false,		// ヘッダの背景画像の表示ON/OFF
		"show-facepile": true,	//「いいね」している友達の表示ON/OFF
		"adapt-container-width": true,		// 表示枠の幅に収まるようサイズを合わせます。
		
		...opt
	};
	
	const attr = {};
	for(let k in def) {
		attr[`data-${k}`] = def[k];
	}
	
	const $fbp = this;
	$fbp.attr(attr);
	
	const href = $fbp.attr("data-href");
	if(!href) {
		throw new Error("initFbPagePlugin: illegal arguments. (no href data)");
	}
	
	(typeof ttl === "string" && ttl) || (ttl = `${document.title} Facebookページ`);
	$("<blockquote/>").attr("cite", href).append(
		$("<a/>").attr({
			href: href,
			target: "_blank"
		}).text(ttl)
	).addClass("fb-xfbml-parse-ignore").prependTo($fbp);
	$fbp.hasClass("fb-page") || $fbp.addClass("fb-page");
	
	initFb(version);
	
	return new Promise(resolve => {
		asyncLoop(() => {
			// 完了チェック
			$fbp.$iframe = $fbp.find("iframe");
			return !!$fbp.$iframe.length;
		}, () => {
			// 完了コールバック
			$fbp.$iframe.on("load", resolve);
		}, 1000);
		
		// timeout
		setTimeout(resolve, 10000);
	});
};
